import { gql } from '@apollo/client';

export const GET_ORDER_CLOSE_CHANNEL_IDS = gql`
    query GetOrderCloseChannelIds {
        getOrderCloseChannelIds {
            temuSmm
            temuFmm
            tiktokCbt
            tiktokFbt
            tiktokGs
            exportEasy
        }
    }
`;

export interface OrderCloseChannelIdsResponse {
    getOrderCloseChannelIds: {
        // GraphQL 的 Long 类型在 JSON 中会被序列化为字符串
        temuSmm: number | string;
        temuFmm: number | string;
        tiktokCbt: number | string;
        tiktokFbt: number | string;
        tiktokGs: number | string;
        exportEasy: number | string;
    };
}
